import { findSelectedNodeOfType } from '@atlaskit/editor-prosemirror/utils';
export var getDatasource = function getDatasource(editorView) {
  var _findSelectedNodeOfTy;
  var _editorView$state = editorView.state,
    selection = _editorView$state.selection,
    schema = _editorView$state.schema;
  var blockCard = schema.nodes.blockCard;
  return (_findSelectedNodeOfTy = findSelectedNodeOfType([blockCard])(selection)) !== null && _findSelectedNodeOfTy !== void 0 ? _findSelectedNodeOfTy : {
    node: undefined,
    pos: undefined
  };
};